import React, { memo, useState } from "react";
import {
  AsyncTypeahead,
  Menu,
  MenuItem,
  Highlighter,
} from "react-bootstrap-typeahead";
import Axios from "../../axios";
//#region Slice Imports
import { useDispatch, useSelector } from "react-redux";
import { setSelectedClient } from "../../Slices/sessionSlice";
//#endregion

// import { Menu, MenuItem, Highlighter } from 'react-bootstrap';

// needs to be extracted from sessionSlice
const candidate = "61dc087d2625b634c8aae6a5";

function SupervisingClientSearchBar() {
  //#region store listeners
  const { selectedClient,sessionUser } = useSelector((state) => state.sessionSlice);
  //#endregion
  //#region local state
  const [clients, setClients] = useState(selectedClient);
  const [laoding, setLoading] = useState(false);
  //#endregion

  const dispatch = useDispatch();

  // onChanage Handler
  const onChangeSearch = (selected) => {
    return dispatch(setSelectedClient(selected));
  };

  // onSearch Handler
  const onSearch = (queryValue) => {
    setLoading(true);
    Axios.get(
      `/api/candidate/search-supervisingClients?query=${queryValue}&&user=${sessionUser._id}`
    )
      .then((res) => {
        //destructure data
        const { results } = res.data;
        setLoading(false);
        setClients(results);
      })
      .catch((err) => {
        console.log("Error :- ", err);
      });
  };

  return (
    <div>
      <AsyncTypeahead
        id="basic-typeahead-single"
        labelKey="name"
        onChange={onChangeSearch}
        isLoading={laoding}
        onSearch={onSearch}
        options={clients}
        placeholder="search cliemt..."
        selected={selectedClient}
        minLength={1}
        size="lg"
        renderMenuItemChildren={(option, props, idx) => {
          return <>{option[props.labelKey]}</>;
        }}
      />
    </div>
  );
}

export default SupervisingClientSearchBar;
